import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { takeReturnTo } from "src/helpers/ReturnTo";
import { APIConnector } from "src/api/APIConnector";

// Where the API sends the browser after company single sign-on (SAML): ?site=..&code=.. on success,
// ?site=..&error=.. otherwise. The code is single-use and short-lived, so it is exchanged exactly once.
const loginPages = {
    client: { path: '/', state: { activeSite: 'CLIENT' } },
    vendor: { path: '/', state: { activeSite: 'VENDOR' } },
    uspto:  { path: '/uspto/login' },
    uscis:  { path: '/uscis/login' },
};

const SsoLanding = () => {
    const api = APIConnector();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState("Signing you in...");
    const [failed, setFailed] = useState(false);
    const exchanged = useRef(false);

    const site = searchParams.get("site");
    const loginPage = loginPages[site] ?? loginPages.client;

    useEffect(() => {
        const code = searchParams.get("code");
        const error = searchParams.get("error");

        if (error || !code || !loginPages[site]) {
            setMessage(error || "Single sign-on failed. Please try again.");
            setFailed(true);
            return;
        }
        if (exchanged.current)
            return;
        exchanged.current = true;

        api.post(`/auth/sso?site=${encodeURIComponent(site)}&code=${encodeURIComponent(code)}`)
            .then((data) => {
                if (data && data.token) {
                    localStorage.setItem('token', data.token);
                    navigate(takeReturnTo(site) || `/${site}/home`, { replace: true });
                } else {
                    setMessage("Single sign-on failed. Please try again.");
                    setFailed(true);
                }
            })
            .catch((err) => {
                setMessage(typeof err === 'string' ? err : "Single sign-on failed. Please try again.");
                setFailed(true);
            });
    }, [searchParams]);

    return <div style={{padding:20}}>
        {message}
        {failed &&
            <p><a href="#" onClick={(e) => { e.preventDefault(); navigate(loginPage.path, { state: loginPage.state }); }}
                  style={{color:'#981239'}}>Return to Login Page</a></p>}
    </div>
}

export default SsoLanding
